import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule],
})
export class Error500RoutingModule {
}
